import apiClient from '@/service/apiClient';

export type ResGetRandom4 = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: {
    id: number;
    name: string;
    location: string;
    categoryId: number;
    categoryName: string;
    villageName: string;
    price: number;
    originPrice: number;
    thumbnailUrl: string;
    productType: string;
  }[];
};

export const getRandom4 = async (): Promise<ResGetRandom4> => {
  const { data } = await apiClient.get<ResGetRandom4>('/app/products/v2/random-4');
  return data;
};
